<template>
  <div>
    <v-text-field
      v-if="useTextField"
      v-model="value"
      placeholder="(default)"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      outlined
      dense
      hide-details
      @input="onTextInput"
      @change="onChanged"
    ></v-text-field>
    <v-checkbox
      v-else-if="useCheckBox"
      v-model="value"
      @change="onChanged"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  name: "SettingEditor",
  props: {
    setting: {
      type: Object,
      default: null,
    },
    dev: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    value: null,
    origValue: null,
    inputTimeout: null,
  }),
  computed: {
    useTextField() {
      return (
        this.setting.typeHint === "null" || this.setting.typeHint === "String"
      );
    },
    useCheckBox() {
      return this.setting.typeHint === "Boolean";
    },
  },
  mounted() {
    const val = this.dev ? this.setting.devValue : this.setting.value;

    if (this.useCheckBox) {
      this.origValue = this.value = JSON.parse(val);
    } else {
      this.origValue = this.value = val;
    }
  },
  methods: {
    onTextInput() {
      clearTimeout(this.inputTimeout);
      this.inputTimeout = setTimeout(() => {
        this.onChanged();
      }, 1500);
    },
    onChanged() {
      const change = {
        key: this.setting.key,
      };

      if (this.dev) {
        change["devValue"] = this.value;
      } else {
        change["value"] = this.value;
      }

      this.$emit("change", change);
    },
  },
};
</script>
